"use strict";

import SwiperCore, { Pagination, Navigation, Lazy } from './swiper/swiper-bundle.js';

SwiperCore.use([Pagination, Navigation, Lazy]);

function getSliderId(container) {
   return container.getAttribute('data-slider-id'); 
}

function getSliderBreakpoint(container) {
   return container.getAttribute('data-slider-breakpoint'); 
}

function getNavButtons(sliderId) {
    if (sliderId) {
        const prev = document.querySelector(`[data-prev-button-for-slider="${sliderId}"]`);
        const next = document.querySelector(`[data-next-button-for-slider="${sliderId}"]`);

        if (prev && next) {
            return { prev, next };
        }
    }

    return false;
}

function getPagination(sliderId) {
    if (sliderId) {
        return document.querySelector(`[data-pagination-for-slider="${sliderId}"]`);
    }

    return false;
}

function newSlider(container, options) {
    const sliderId = getSliderId(container);
    const navButtons = getNavButtons(sliderId);
    const pagination = getPagination(sliderId);

    if (navButtons) {
        options.navigation = {
            nextEl: navButtons.next,
            prevEl: navButtons.prev,
        };
    }

    if (pagination) {
        options.pagination = {
            el: pagination,
            type: 'bullets',
            clickable: true,
        };
    }
    
    return new SwiperCore(container, options);
}

function showPagination(pagination) {
    if (pagination) {
        pagination.style.display = '';
    }
}

function hidePagination(pagination) {
    if (pagination) {
        pagination.style.display = 'none';
    }
}

function newBreakpointSlider(container, breakpoint, options) {
    const sliderId = getSliderId(container);
    const pagination = getPagination(sliderId);
    const mm = window.matchMedia(`(max-width:${breakpoint}px)`);
    let slider;

    if (mm.matches) {
        slider = newSlider(container, options);
    }

    mm.addEventListener('change', e => {
        if (!e.matches && slider) {
            hidePagination(pagination);
            slider.destroy();
        } else if (e.matches) {
            showPagination(pagination);
            slider = newSlider(container, options);
        }
    });
}

function initSlider(container, options) {
    const breakpoint = getSliderBreakpoint(container);
    let slider;
    
    if (breakpoint) {
        slider = newBreakpointSlider(container, breakpoint, options);
    } else {
        slider = newSlider(container, options);
    }

    return slider;
}

export default function createSliders(sliderClass, options) {
    const sliderElements = Array.from(document.getElementsByClassName(sliderClass));
    const sliders = sliderElements.map(slider => initSlider(slider, options));

    return sliders;
}
